<kl-share-update-form
  (postCreated)="onPostCreated($event);"
  [postDetails]="dialogData.data.postDetails"
  [reShareDetails]="true">
</kl-share-update-form>
